import React from 'react';
import './members.scss';
import katPfp from './kat-pfp.jpg';
import emilyPfp from './emily-pfp.png';
import oliviaQr from './olivia-qr.png';
import oliviaPfp from './olivia-pfp.png';
import adelleQr from './adelle-qr.png';
import adellePfp from './adelle-pfp.png'
import kagiQr from './kagi-qr.png';
import kagiPfp from './kagi-pfp.jpg';
import allisonQr from './allison-qr.png';
import allisonPfp from './allison-pfp.png';
import jinQr from './jin-qr.png';
import jinPfp from './jin-pfp.jpg';

interface Artist {
  name: string;
  photo: string;
  qr: string;
  bio: string;
  website: string;
}


const Members = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const artists: Artist[] = [
    {'name': 'Toki (Kat)', 'photo': katPfp, 'qr':'', 'bio': 'Kat is a tattoo artist and started Ricecake Collective with Lilian. She has always loved to draw and recently quit her job as a Software Engineer at Google to pursue art full-time.', 'website': 'https://www.instagram.com/toki.tattoos/'},
    {'name': 'Summertime Emmy', 'photo': emilyPfp, 'qr':'', 'bio': 'I’m Emily (she/her), the artist behind Summertime Emmy! I make a collection full of playful, meaningful gifts—from shiny sticker sheets to dreamy tarot decks. Perfect for those who seek a nolgastic touch, mental health moments, and thoughtful little treasures.', 'website': 'https://summertimeemmy.com/pages/home'},
    {'name': 'Adelle (InkyBearDoodles)', 'photo': adellePfp, 'qr':adelleQr, 'bio': 'Hi there! My name is Adelle, and I’m a web engineer who loves to crochet and design silly stickers in her free time. I\'ve always loved creating things, and InkyBearDoodles is a passion project I started as a way to connect with fellow artists and sticker fanatics. I enjoy incorporating wordplay in my designs, and I\'d describe my style as cute and cartoony. This is my second vending experience with RiceCake at SJMade, and I\'m excited to be joining in person for the first time!', 'website': 'https://www.instagram.com/inkybeardoodles/'},
    {'name': 'soupism__', 'photo': allisonPfp, 'qr': allisonQr, 'bio': 'Hello! I’m soupism__ , a visual development artist & illustrator based in the Bay Area. I enjoy creating pieces inspired by fashion, small moments in everyday life, and my culture as a Vietnamese-American. I hope my work creates a sense of comfort - filled with childhood nostalgia & the joys of living day to day!', 'website': 'https://soupyallison.carrd.co/'},
    {'name': 'jin / 단아', 'photo': jinPfp, 'qr':jinQr, 'bio': 'jin / 단아 is a multimedia artist born and based in the Bay Area. Their works often include mediums such as textiles, beads, and other fiber arts. They enjoy exhibiting works reflecting on their Korean heritage and vending goods they’ve made.', 'website': 'https://dannakim.journoportfolio.com/'},
    {'name': 'Olivia When', 'photo': oliviaPfp, 'qr': oliviaQr, 'bio': 'Olivia When is an illustrator and 2D animator. She recently illustrated her first children’s book The Day Leap Soared written by Blair Braverman. After 10 years working on Google Doodles, she’s currently freelancing, sleeping, and painting as many dogs as possible.', 'website': 'https://oliviawhen.com/store'},
    {'name': 'kagicider', 'photo': kagiPfp, 'qr':kagiQr, 'bio': 'Hi, I’m Lucy, and I created kagicider, a small, artist-run brand creating cute, playful, and tactile merchandise, including 3-D printed keychains and watercolors. I’m inspired by old video game aesthetics and nostalgia.', 'website': 'https://kagicider.com/'},

  ];

  const routeChange = (path: string) =>{ 
    window.location.href = path;
  }


  const getArtistElement = (artist: Artist) => {
    return (
      <div className='Artist'>
        <div className='name'>{artist.name}</div>
        <div className='photo'><img src={artist.photo}></img></div>
        <div className='bio'>{artist.bio}</div>
        <div className='more'>
          <button className='moreButton' onClick={() => routeChange(artist.website)}>Visit Site</button>
        </div>
        <hr className='separator'></hr>
      </div>
    )

  };

  const getAllArtistElements = (artists: Artist[]) => {
    return artists.map((artist)=> {
      return getArtistElement(artist);
    });
  }

  return (
  <div className='page members'>
  <div className='title'>Ricecake Collective Artists</div>
  {
    getAllArtistElements(artists)
  }
  </div>
  );
}

export default Members;
